import PropTypes from 'prop-types';

const TitlesSection = ({ header, children, styleClass = '' }) => {
    return <div className={`titles-section ${styleClass}`}>
        <div><h4 className="section-header">{header}</h4></div>
        <div>{children}</div>
    </div>;
};

TitlesSection.propTypes = {
    header: PropTypes.string,
    children: PropTypes.node,
    styleClass: PropTypes.string,
};

export default TitlesSection;